import React from "react";
import clsx from "clsx";
import { makeStyles } from "@mui/material/styles";
import NoSsr from "@mui/material/NoSsr";

const fontSizes = {
  extraSmall: {
    fontSize: 10,
  },
  small: {
    fontSize: 20,
  },
  medium: {
    fontSize: 25,
  },
  large: {
    fontSize: 40,
  },
};

/**
 * Component to display the icon
 *
 * @param {Object} props
 */
const Icon = ({
  fontIconClass,
  size,
  fontIconColor,
  style,
  className,
  ...rest
}: IconProps): JSX.Element => {
  return (
    <NoSsr>
      <i
        className={clsx("icon", fontIconClass, className)}
        style={{
          color: fontIconColor,
          ...(size ? { fontSize: fontSizes[size].fontSize } : {}),
          ...style,
        }}
        {...rest}
      />
    </NoSsr>
  );
};

export default Icon;
